import { handleApiError } from '../utils/apiUtils';

let API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8788';

// Safely ensure the URL has a protocol if the environment variable is missing it
if (API_BASE_URL && !API_BASE_URL.startsWith('http')) {
  API_BASE_URL = 'https://' + API_BASE_URL;
}
const BEARER_TOKEN = process.env.REACT_APP_BEARER_TOKEN;

const apiCall = async (endpoint = '', options = {}) => {
  try {
    const url = endpoint ? `${API_BASE_URL}${endpoint}` : API_BASE_URL;
    const config = {
      method: 'GET',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(BEARER_TOKEN && { Authorization: `Bearer ${BEARER_TOKEN}` }),
        ...options.headers,
      },
    };

    console.log('Making API call to:', url);
    console.log('Request config:', config);

    const response = await fetch(url, config);
    
    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);
    
    // Try to get response text for better error details
    const responseText = await response.text();
    console.log('Response text:', responseText);
    
    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;
      
      // Try to parse error details from response
      try {
        const errorData = JSON.parse(responseText);
        if (errorData.error) {
          errorMessage += ` - ${errorData.error}`;
        } else if (errorData.message) {
          errorMessage += ` - ${errorData.message}`;
        }
      } catch (parseError) {
        // If response is not JSON, include the text
        if (responseText) {
          errorMessage += ` - ${responseText}`;
        }
      }
      
      throw new Error(errorMessage);
    }
    
    // Parse JSON response
    const data = JSON.parse(responseText);
    return { success: true, data };
  } catch (error) {
    const errorMessage = handleApiError(error);
    console.error('API call failed:', errorMessage);
    return { success: false, error: errorMessage };
  }
};

export const createUser = async (userData) => {
  console.log('API createUser called with:', userData);
  console.log('Data type:', typeof userData, userData instanceof FormData ? 'FormData' : 'Object');
  
  // Map the form data to match the expected API format
  const formattedData = {
    name: userData.name,
    email: userData.email,
    rollNo: userData.rollNo,
    branch: userData.branch,
    cgpa: userData.cgpa ? parseFloat(userData.cgpa) : null,
    skillType: userData.skillType,
    primaryDepartment: userData.primaryDepartment,
    secondaryDepartment: userData.secondaryDepartment,
    previousExperience: userData.previousExperience,
    otherSocieties: userData.otherSocieties,
    photo: userData.photo,
    github: userData.github,
    linkedin: userData.linkedin,
    remarks: userData.remarks
  };
  
  console.log('Formatted data for API:', formattedData);
  console.log('JSON stringified data:', JSON.stringify(formattedData));
  console.log('Bearer token present:', !!BEARER_TOKEN);
  console.log('API Base URL:', API_BASE_URL);
  
  const result = await apiCall('/api/submit', {
    method: 'POST',
    body: JSON.stringify(formattedData),
  });
  
  console.log('API: Create user response:', result);
  
  return result;
};

export const fetchSubmissions = async (adminPassword) => {
  return apiCall('/api/admin/submissions', {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${adminPassword}`
    }
  });
};

export const apiService = {
  createUser,
  fetchSubmissions,
};

export default apiService;